import script from "./MazdaPageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MazdaPageHeader.vue?vue&type=script&setup=true&lang=js"

import "./MazdaPageHeader.vue?vue&type=style&index=0&id=cd6ef444&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd6ef444"]])

export default __exports__